var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoInvisionDarkBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 152,
    height: 46,
    viewBox: "0 0 152 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 132.249,
    height: 44.477
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Custom_Size_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 46
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Custom_Size_1",
    "data-name": "Custom Size \\u2013 1",
    clipPath: "url(#clip-Custom_Size_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-invision",
    transform: "translate(7.875 -0.015)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_",
    transform: "translate(0.139 0.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    d: "M45.112,13.591H8.874a4.029,4.029,0,0,0-4.014,4.014V53.844a4.029,4.029,0,0,0,4.014,4.014H45.112a4.029,4.029,0,0,0,4.014-4.014V17.606a4.029,4.029,0,0,0-4.014-4.014Z",
    transform: "translate(-4.859 -13.591)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    d: "M34.085,35.551h4.232V17.07H34.085ZM49.565,24.629c-2.17-.687-4.159-1.266-4.159-2.6v-.072c0-1.085.94-1.845,2.6-1.845a8.271,8.271,0,0,1,2.64.506h.036a1.765,1.765,0,0,0,.253.109c.687.217,2.459.506,4.014-1.881a12.747,12.747,0,0,0-6.8-2.1c-3.689,0-6.582,2.134-6.582,5.642v.072c0,3.544,3.038,4.665,5.787,5.425,2.17.651,4.123,1.157,4.123,2.6v.072c0,1.23-1.049,1.989-2.857,1.989a9.466,9.466,0,0,1-3.87-.94c-.4-.145-2.351-.832-4.051,1.555a12.934,12.934,0,0,0,7.812,2.749c3.834,0,6.872-1.917,6.872-5.823v-.072C55.315,26.69,52.277,25.461,49.565,24.629Zm-27.016,6.04-4.955-13.6H13.037L20.632,35.7h3.8L31.988,17.07H27.54Zm52.441-14a9.666,9.666,0,0,0-9.873,9.693,9.559,9.559,0,0,0,9.8,9.584,9.641,9.641,0,1,0,.072-19.277Zm0,15.624a5.735,5.735,0,0,1-5.642-6c0-3.255,2.17-5.931,5.57-5.931a5.742,5.742,0,0,1,5.678,6C80.559,29.656,78.389,32.3,74.989,32.3ZM97.376,16.672a6.721,6.721,0,0,0-5.787,3.255V17.07H87.358V35.551H91.59V25.135c0-2.857,1.7-4.593,4.159-4.593,2.532,0,3.942,1.627,3.942,4.521V35.551h4.231V23.8C103.959,19.493,101.535,16.672,97.376,16.672ZM58.1,35.551h4.231V17.07H58.1Z",
    transform: "translate(28.048 -1.193)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    d: "M9.976,20.65a2.677,2.677,0,1,0-2.712-2.676A2.678,2.678,0,0,0,9.976,20.65Z",
    transform: "translate(4.816 -6.726)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    d: "M7.557,28.91A10.328,10.328,0,0,0,7.3,30.9c0,2.351,1.266,3.906,3.978,3.906,2.242,0,4.051-1.338,5.353-3.472l-.8,3.219h4.448l2.532-10.2c.651-2.568,1.881-3.942,3.725-3.942a2.215,2.215,0,0,1,2.387,2.423,5.448,5.448,0,0,1-.181,1.447l-1.3,4.7a7.78,7.78,0,0,0-.289,1.989c0,2.242,1.3,3.87,4.051,3.87,2.351,0,4.231-1.519,5.244-5.136l-1.736-.687c-.868,2.423-1.627,2.857-2.242,2.857-.579,0-.9-.4-.9-1.194a5.6,5.6,0,0,1,.181-1.23L33.018,24.9A9.859,9.859,0,0,0,33.452,22c0-3.436-2.061-5.208-4.557-5.208-2.351,0-4.738,2.1-5.931,4.34l.868-4.014h-6.8l-.94,3.508h3.183l-1.953,7.848c-1.555,3.436-4.376,3.472-4.7,3.4-.579-.145-.94-.362-.94-1.121a6.75,6.75,0,0,1,.289-1.808L14.935,17.12H7.412l-.94,3.508H9.618Z",
    transform: "translate(1.63 -0.701)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInvisionDarkBlue);
export default __webpack_public_path__ + "static/media/logo-invision-dark-blue.68ba2170d1660ebe0423e455ccf2a84b.svg";
export { ForwardRef as ReactComponent };